import { colors, fonts } from '@grupoboticario/flora-tokens/beautybox/web/ds'

export const beautybox = {
  colors,
  fonts,
}
